import React from 'react';
import Lottie from 'react-lottie';
import './Phone_Lottie.css';
import * as animationData from './Phone_Lottie.json';

function Phone_Lottie(){
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
      };
    
    return (
      <section className='main'>
            <div className='Phone_Lottie_icon'>
                <Lottie className="me-auto"
                options={defaultOptions}        
                />       
        </div>
      </section>
    );
}
export default Phone_Lottie;